import React from "react";
import ModalFormUI from "../../../widgets/form/ModalFormUI";
import InputTextSF from "../../../widgets/form/InputTextSF";
import InputSelectSF from "../../../widgets/form/InputSelectSF";


const InvoiceItemCreateModalUI = ({
	context, successMsg, errorList, setErrorList,
	createMode, onSubmit, submitted, onCancelCreate,
	productItemId, onProductItemIdChange, productItemIdError, setProductItemIdError,
	quantity, onQuantityChange, quantityError, setQuantityError,
	invoiceItemList

}) =>
	<ModalFormUI
		context={context}
		titleLabel='Add Invoice Item'
		buttonLabel='Add'
		cancelLabel='Cancel'
		isOpen={createMode}
		onRequestClose={onCancelCreate}
		successMsg={successMsg}
		errorList={errorList}
		setErrorList={setErrorList}
		onSubmit={onSubmit}
		busy={submitted}
	>

		<div className='col'>
			<InputSelectSF type='text' name='itemName'
				label='Item'
				value={productItemId} onChange={onProductItemIdChange}
				error={productItemIdError} setError={setProductItemIdError}
				optionList={invoiceItemList.map(item => ({ key: item.productItemId, value: item.itemName }))}
			/>
			<InputTextSF type='text' name='quantity' maxLength={40}
				label='Quantity'
				value={quantity} onChange={onQuantityChange}
				error={quantityError} setError={setQuantityError}
			/>

		</div>

	</ModalFormUI>

export default InvoiceItemCreateModalUI;
